import { BaseHandler } from '../../abstracts';
import { LogChannel } from '../../constants';
import { LoggingMessageInterface } from '../../models';
import { Injectable } from '@angular/core';

@Injectable()
export class OfflineLoggingHandler extends BaseHandler<LogChannel, void> {
  protected channelToSubscribe: LogChannel;

  createSetup(): void {
    // No setup needed
  }

  init(logChannel: LogChannel): void {
    this.channelToSubscribe = logChannel;
    this.createSubscription();
  }

  protected messageHandler = (value: LoggingMessageInterface) => {
    console.log(value);
  };
}
